import React from 'react';
import { CRow, CCol } from '@coreui/react-pro';
import { Modal } from 'react-bootstrap';
import { CXButton } from '../../../components/CXForm';
import CXFPConfigTextArea from '../../../components/CXForm/CXFPConfigTextArea';

type EmailToState = {
    assigneeLead: boolean;
    assigneeGroup: boolean;
    caseCreator: boolean;
};

type EmailContentState = {
    includeRemarkContent: boolean;
    includeRemarkAttachments: boolean;
    freeText: boolean;
    freeTextValue: string;
};

type Props = {
    show: boolean;
    onHide: () => void;

    emailTo: EmailToState;
    setEmailTo: React.Dispatch<React.SetStateAction<EmailToState>>;

    emailContent: EmailContentState;
    setEmailContent: React.Dispatch<React.SetStateAction<EmailContentState>>;

    onSend: () => void;
};

export default function EmailModal(props: Props) {
    const {
        show,
        onHide,
        emailTo,
        setEmailTo,
        emailContent,
        setEmailContent,
        onSend,
    } = props;

    return (
        <Modal
            className="emailModal"
            show={show}
            onHide={onHide}
            size="xl"
        >
            <Modal.Header className="modal-header" closeButton>
                <Modal.Title>Create email</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <CRow>
                    <CCol xs={6} style={{ paddingTop: 6 }}>
                        <span style={{ fontSize: 16, color: '#4C4C4C' }}>Send email to</span>
                    </CCol>
                    <CCol xs={6}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                            <label className="emailCheckbox">
                                <input
                                    type="checkbox"
                                    checked={emailTo.assigneeLead}
                                    onChange={() =>
                                        setEmailTo((prev) => ({
                                            ...prev,
                                            assigneeLead: !prev.assigneeLead,
                                        }))
                                    }
                                />
                                <span>Assignee lead</span>
                            </label>
                            <label className="emailCheckbox">
                                <input
                                    type="checkbox"
                                    checked={emailTo.assigneeGroup}
                                    onChange={() =>
                                        setEmailTo((prev) => ({
                                            ...prev,
                                            assigneeGroup: !prev.assigneeGroup,
                                        }))
                                    }
                                />
                                <span>Assignee group</span>
                            </label>
                            <label className="emailCheckbox">
                                <input
                                    type="checkbox"
                                    checked={emailTo.caseCreator}
                                    onChange={() =>
                                        setEmailTo((prev) => ({
                                            ...prev,
                                            caseCreator: !prev.caseCreator,
                                        }))
                                    }
                                />
                                <span>Case creator</span>
                            </label>
                        </div>
                    </CCol>
                </CRow>

                <hr style={{ margin: '24px 0' }} />

                <CRow>
                    <CCol xs={6} style={{ paddingTop: 6 }}>
                        <span style={{ fontSize: 16, color: '#4C4C4C' }}>Email content</span>
                    </CCol>
                    <CCol xs={6}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                            <label className="emailCheckbox">
                                <input
                                    type="checkbox"
                                    checked={emailContent.includeRemarkContent}
                                    onChange={() =>
                                        setEmailContent((prev) => ({
                                            ...prev,
                                            includeRemarkContent: !prev.includeRemarkContent,
                                        }))
                                    }
                                />
                                <span>Include remark content</span>
                            </label>
                            <label className="emailCheckbox">
                                <input
                                    type="checkbox"
                                    checked={emailContent.includeRemarkAttachments}
                                    onChange={() =>
                                        setEmailContent((prev) => ({
                                            ...prev,
                                            includeRemarkAttachments: !prev.includeRemarkAttachments,
                                        }))
                                    }
                                />
                                <span>Include remark attachments</span>
                            </label>
                            <label className="emailCheckbox">
                                <input
                                    type="checkbox"
                                    checked={emailContent.freeText}
                                    onChange={() =>
                                        setEmailContent((prev) => ({
                                            ...prev,
                                            freeText: !prev.freeText,
                                        }))
                                    }
                                />
                                <span>Free text content</span>
                            </label>

                            <div className="emailFreeTextWrapper">
                                <CXFPConfigTextArea
                                    maxRows={21}
                                    value={emailContent.freeTextValue}
                                    placeholder="Free text content"
                                    onChangeField={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
                                        setEmailContent((prev) => ({
                                            ...prev,
                                            freeTextValue: e.target.value,
                                        }))
                                    }
                                    disabled={!emailContent.freeText}
                                />
                            </div>
                        </div>
                    </CCol>
                </CRow>
            </Modal.Body>

            <Modal.Footer className="modal-footer">
                <div style={{ width: 200 }}>
                    <CXButton
                        outline
                        text="Cancel"
                        onClick={onHide}
                        fontSize="16px"
                        width="100%"
                    />
                </div>
                <div style={{ width: 200 }}>
                    <CXButton
                        text="Send email"
                        onClick={onSend}
                        fontSize="16px"
                        width="100%"
                    />
                </div>
            </Modal.Footer>
        </Modal>
    );
}
